import mapiConfig from "../configs/mapi";
import { httpMStepsClient } from "./utils/httpService";
import sapiConfig from "../configs/sapi";

//BASE_URL
const MAPI_BASE_URL = mapiConfig.api.domain;
const SAPI_BASE_URL = sapiConfig.api.domain;
const Controller = "/customer";

export const getPortalSalesOrder = async (queryParams: any) => {
  const methodPath = `${Controller}/portal-orders?${queryParams.toString()}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getPortalIssuesHistory = async (queryParams: any) => {
  const methodPath = `${Controller}/issues?${queryParams.toString()}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const createIssueOrder = async (payload: any) => {
  const methodPath = `${Controller}/issues`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: payload,
  });
};

export const retrieveIssueSummary = async (issueId: any) => {
  const methodPath = `${Controller}/issues/${issueId}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const updateIssueOrder = async (issueId: string, payload: any) => {
  const methodPath = `${Controller}/issues/${issueId}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "PATCH",
    path: methodPath,
    body: payload,
  });
};

export const shareIssueToOperation = async (payload: any) => {
  const methodPath = `${Controller}/issues/share-operation`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: payload,
  });
};

export const manualUpdateCustomerOrderStatus = async (
  _id: string,
  payload: any,
) => {
  const methodPath = `${Controller}/manual/portal-delivery-report/${_id}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
    body: payload,
  });
};
